<div class="help-card-container" ngbDropdown #helpDrop="ngbDropdown">
  <div class="help-card" id="helpCard" ngbDropdownToggle>
    <a href="javascript:void(0)">      
      <span class="fa-solid fa-circle-question fa-2xl" style="
    color: #284a7b;
"></span>
    </a>
  </div>
  <div ngbDropdownMenu aria-labelledby="helpCard">
    <div class="dd-menu-header">Help</div>
    <div class="dd-menu-separator"></div>
    <!--<button class="dd-menu-item" ngbDropdownItem>FAQ</button>-->
    <button class="dd-menu-item" ngbDropdownItem (click)="contactSupport()">Contact Support</button>

  </div>
</div> 
